export default __webpack_public_path__ + "static/media/Harness of Righteous Smiting.d28ec470.jpg";